import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/logo.svg'


const _hoisted_1 = {
  class: "surface-overlay px-4 md:px-6 lg:px-8 flex align-items-center justify-content-center relative",
  style: {"min-height":"100vh"}
}
const _hoisted_2 = { class: "text-center mb-5" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Image",
  height: "100",
  class: "mb-3"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-900 text-3xl font-medium mb-3" }, " Welcome Back ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "text-600 font-medium line-height-3" }, " Don't have an account? ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  for: "email1",
  class: "block text-900 font-medium mb-2"
}, " Email ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "password1",
  class: "block text-900 font-medium mb-2"
}, " Password ", -1)
const _hoisted_8 = { class: "flex align-items-center justify-content-center mb-6" }
const _hoisted_9 = { class: "flex align-items-center p-error" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_spinner = _resolveComponent("spinner")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Password = _resolveComponent("Password")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_spinner, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("form", {
      onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["prevent"])),
      class: "surface-card p-4 shadow-2 border-round w-full lg:w-6"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _createVNode(_component_router_link, {
          to: { name: _ctx.routeNames.register },
          class: "font-medium no-underline ml-2 text-blue-500 cursor-pointer"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Create today! ")
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("div", null, [
        _hoisted_6,
        _createVNode(_component_InputText, {
          modelValue: _ctx.email,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
          required: "",
          id: "email1",
          type: "text",
          placeholder: "Email address",
          class: "w-full mb-3"
        }, null, 8, ["modelValue"]),
        _hoisted_7,
        _createVNode(_component_Password, {
          modelValue: _ctx.password,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
          feedback: false,
          required: "",
          id: "password1",
          placeholder: "Password",
          class: "w-full mb-3",
          "input-class": "w-full mb-3"
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.errorMessage), 1)
        ]),
        _createVNode(_component_Button, {
          type: "submit",
          label: "Sign In",
          icon: "pi pi-user",
          class: "w-full"
        })
      ])
    ], 32)
  ]))
}